export const enum InputWidgetButtonAction {
    Ok = 'Ok',
    Edit = 'Edit',
    Close = 'Close',
    Retry = 'Retry',
    LocalOk = 'LocalOk',
    LocalClose = 'LocalClose',
    LocalCancel = 'LocalCancel',
}
